import * as _ from 'underscore';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import AddedExercise from './AddedExercise';
import TrophyIcon from '../../../lib/icons/TrophyIcon';
import * as Utils from '../../../lib/designerUtils';
import Console from '../../../lib/debug';
import { redzoneTypes } from '../../../lib/paramTypes';
import InstructionVisibilityContext from '../../../view/fullScreenWorkout/InstructionVisibilityContext';

class AddedBlock extends Component {
    static contextType = InstructionVisibilityContext;

    getBlockUrl() {
        let session = this.props.session;
        let sessionId = this.props.session.id;
        let programId = this.props.programId;
        let year = session.year;
        let month = session.month;
        let day = session.day;
        const YMDSId = `/day/${year}/${month}/${day}/${sessionId}`;
        if (this.props.programType === 0) {
            return `#/team/calendar/${programId}${YMDSId}`;
        } else if (this.props.programType === 1) {
            return `#/calendar/${programId}${YMDSId}`;
        } else if (this.props.programType === 2) {
            let indexDay = session.timeline_day - 1;
            let week = Math.floor(indexDay / 7);
            let _day = indexDay - week * 7;
            return `#/program/calendar/${programId}/day/${week}/${_day}`;
        }
    }

    getLeaderboardTag(type) {
        if (type) {
            return `FOR ${
                _.find(redzoneTypes, { id: type }).title
            }`.toUpperCase();
        } else {
            return '';
        }
    }

    getCircuitTitle(id) {
        if (Object.keys(this.props.exerciseBenchmarkRef).length) {
            let found = _.find(this.props.exerciseBenchmarkRef, { id });
            if (found) return found.label;
            else return Utils.getBlockTitleWithFallback(this.props.block);
        }
        return Utils.getBlockTitleWithFallback(this.props.block);
    }

    render() {
        Console.render('AddedBlock');
        let block = this.props.block;

        if (!block) {
            return null;
        }

        let session = this.props.session;
        let last = this.props.last;
        let isPreview = this.props.isPreview;
        let programId = this.props.programId;
        let progressWM = null;
        let personalRecord = null;
        let outstandingDetail = null;
        let calendarInstructionsEnabled =
            this.props.calendarInstructionsEnabled || this.context;
        let calendarBlockNamesEnabled = this.props.calendarBlockNamesEnabled;
        let elements = [];

        if (block && block.addedExercises && block.addedExercises.length) {
            for (let i = 0; i < block.addedExercises.length; i++) {
                let isLast =
                    block.addedExercises.length - 1 === i ? true : false;
                elements.push(
                    <AddedExercise
                        key={'ex' + i}
                        position={i + 1}
                        session={session}
                        item={block.addedExercises[i]}
                        programId={programId}
                        isPreview={isPreview}
                        calendarInstructionsEnabled={
                            calendarInstructionsEnabled
                        }
                        block={block}
                        isLast={isLast}
                    />
                );
            }
        } else {
            elements.push(
                <AddedExercise
                    key="ex0"
                    position={1}
                    exerciseKey={[]}
                    block={block}
                    session={session}
                    calendarInstructionsEnabled={calendarInstructionsEnabled}
                    isLast={null}
                    programId={programId}
                    isPreview={isPreview}
                />
            );
        }

        let classes = `item-section wstype-${block.type} ${last ? 'last' : ''}`;
        let iconClasses = `icon-section category-icon wstype-${block.type}`;
        let typeBlock = null;
        let redzoneValue = null;
        let leaderboardTag = null;
        let testTag = null;
        if (this.props.summary) {
            if (
                this.getLeaderboardTag(this.props.summary.redzone_type) !== ''
            ) {
                leaderboardTag = (
                    <div className="leaderboard-tag block-leaderboard">
                        <TrophyIcon className="trophy-icon" />{' '}
                        {this.getLeaderboardTag(
                            this.props.summary.redzone_type
                        )}
                    </div>
                );
            }
        }
        let instruction = null;
        if (block.plain_text === 1) {
            let noLine = true;
            let summaryLeaderBoardTag = null;
            let exerciseClasses = `item-section-exercise ${
                noLine ? 'no-line' : ''
            }`;
            let blockIndex = 0;
            let blockKey = block.key || block.id;
            let typeB = typeof blockKey;
            if (typeB === 'string') {
                for (var i = 0; i < session.keys.length; i++) {
                    if (session.keys[i] === blockKey) {
                        blockIndex = i;
                    }
                }
            } else {
                if (session.setKeys) {
                    if (
                        typeof block.key === 'string' &&
                        block.key.indexOf('k::') >= 0
                    ) {
                        blockIndex = session.setKeys.indexOf(blockKey);
                    } else {
                        blockIndex = session.setKeys.indexOf(
                            parseInt(blockKey, 10)
                        );
                    }
                } else {
                    blockIndex = _.findIndex(session.workoutSets, {
                        id: parseInt(blockKey, 10)
                    });
                }
            }
            let subtitle = Utils.getBlockTitle(blockIndex);
            let subtitleSummary = Utils.getBlockTitle(blockIndex);

            let subtitleClass = 'alphabet-icon';
            let subtitleClassSummary = 'alphabet-icon';

            // let prescriptionClass = 'prescription';
            // let prescriptionClassSummary = 'prescription';

            let summary = this.props.summary;
            let sessionSummary = this.props.sessionSummary;
            let logged = sessionSummary ? sessionSummary.logged : false;

            if (summary && summary.completed === 1 && logged) {
                subtitleClassSummary += ' fill-color-green';
                subtitleSummary = <i className="mdi mdi-check" />;
            } else if (summary && logged) {
                subtitleClassSummary += ' fill-color-red';
                subtitleSummary = <i className="mdi mdi-close" />;
            }

            if (summary && logged) {
                if (
                    this.props.summary.is_wm &&
                    this.props.summary.is_up === 1
                ) {
                    progressWM = (
                        <div className="orange-span">
                            <span className="orange-span">
                                <i className="mdi mdi-arrow-up" />WM{' '}
                            </span>{' '}
                        </div>
                    );
                } else if (
                    this.props.summary.is_wm &&
                    this.props.summary.is_up === 0
                ) {
                    progressWM = (
                        <div className="orange-span">
                            <span className="orange-span">
                                <i className="mdi mdi-arrow-down" />WM
                            </span>
                        </div>
                    );
                }

                if (
                    this.props.summary.redzone_value &&
                    this.props.summary.redzone_value !== ''
                ) {
                    summaryLeaderBoardTag = (
                        <span className="leaderboard-tag-value">
                            ({this.props.summary.redzone_value})
                        </span>
                    );
                }
                personalRecord = this.props.summary.is_pr ? (
                    <div className="orange-span">
                        <span className="orange-span">
                            <i className="mdi mdi-star" />PR
                        </span>
                    </div>
                ) : null;
                outstandingDetail = (
                    <div className="extra-detail">
                        {leaderboardTag}
                        {progressWM}
                        {personalRecord}{' '}
                    </div>
                );
            }
            let title = (
                <strong className="title">
                    {this.getCircuitTitle(block.workout_combo_id)}
                </strong>
            );

            if (this.props.block.redzone_type !== 0) {
                leaderboardTag = (
                    <div className="leaderboard-tag">
                        <TrophyIcon className="trophy-icon" />
                        {this.getLeaderboardTag(this.props.block.redzone_type)}
                        {summaryLeaderBoardTag}
                    </div>
                );
            }
            if (!isPreview) {
                title = (
                    <strong className="title">
                        <span>
                            {this.getCircuitTitle(block.workout_combo_id)}
                        </span>
                    </strong>
                );
            }

            elements = (
                <li className={exerciseClasses}>
                    <div className="default-view">
                        <div className="exercise-title">
                            <span className={subtitleClass}>{subtitle}</span>
                            <div className="exercise-title-info">
                                {title}
                                <span className="prescription" />
                            </div>
                        </div>
                        {leaderboardTag}
                    </div>
                    <div className="summary-view circuit-summary">
                        <div className="exercise-title">
                            <span className={subtitleClassSummary}>
                                {subtitleSummary}
                            </span>
                            <div className="exercise-title-info">
                                {title}
                                <span className="prescription" />
                            </div>
                        </div>
                        {leaderboardTag}
                    </div>
                </li>
            );
        }

        if (block.resets_working_max) {
            testTag = (
                <div className="test-tag">
                    <i className="mdi mdi-flash" />
                    <span>Test</span>
                </div>
            );
        }

        if (calendarInstructionsEnabled) {
            instruction = !/^\s+$/g.test(block.instruction) ? (
                <pre className="description-toggle">{block.instruction}</pre>
            ) : null;
        }

        let blockName = null;
        if (calendarBlockNamesEnabled && !isPreview) {
            blockName = <h4 className="toc-block-title">{block.title}</h4>;
        }

        return (
            <li>
                {blockName}
                <div className={classes}>
                    <div className="description-section">
                        {testTag}
                        <ol className="calendar-items-list exercises-list">
                            {elements}
                        </ol>
                        {outstandingDetail}
                        {instruction}
                        {redzoneValue}
                    </div>
                    <div className={iconClasses}>
                        <i className={`wstype-${block.type}`} />
                    </div>
                    <div className="type-block-icon">{typeBlock}</div>
                </div>
            </li>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    const block = state.summary.calendarSummaryAddedSets[ownProps.setKey];
    let workoutId = ownProps.session.workout_id;

    return {
        block,
        summary: block,
        calendarInstructionsEnabled:
            state.calendar.uiTree.calendarInstructionsEnabled,
        calendarBlockNamesEnabled:
            state.calendar.uiTree.calendarBlockNamesEnabled,
        exerciseBenchmarkRef: state.library.exerciseBenchmarkRef,
        sessionSummary: state.summary.calendarSummarySessionTree[workoutId],
        ...ownProps
    };
};

export default connect(mapStateToProps)(AddedBlock);



// WEBPACK FOOTER //
// ./src/v5/addedBlocks/components/AddedBlock.jsx